import { isNil } from 'lodash';
import styled from 'styled-components';
import { Order } from '../../../utils/apollo/graphqlSchema';
import KubitTooltip from '../../KubitTooltip';
import { TableSortType } from '../interfaces';
import * as ChartAnalysisTableUI from './ChartAnalysisTableUI';
import { theme } from '../../../styles/theme';
import { TableSortIcon } from '../../Icon';

const DisplayText = styled.div<{ $isColumnSorted: boolean }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover {
    color: ${theme.colors.mainBlue};
  }

  ${({ $isColumnSorted }) =>
    $isColumnSorted &&
    `
    width: calc(100% - 24px);
  `}'
`;

interface IProps {
  display: string;
  columnIndex: number;
  sortColumnIndex: number | null;
  sortDirection?: Order;
  onSort: (columnIndex: number, sortType?: TableSortType) => void;
}

export default ({
  display,
  columnIndex,
  sortColumnIndex,
  sortDirection,
  onSort,
}: IProps) => {
  const isActive = sortColumnIndex === columnIndex && !isNil(sortDirection);

  return (
    <ChartAnalysisTableUI.SortableContainer onClick={() => onSort(columnIndex)}>
      {isActive ? (
        <KubitTooltip
          content={sortDirection === Order.Asc ? 'Ascending' : 'Descending'}
          placement="bottom-start"
          noOpenDelay={true}
        >
          <DisplayText $isColumnSorted={isActive}>{display}</DisplayText>
        </KubitTooltip>
      ) : (
        <DisplayText $isColumnSorted={isActive}>{display}</DisplayText>
      )}
      {isActive && (
        <TableSortIcon
          isSortAsc={sortDirection === Order.Asc}
          isActive={true}
        />
      )}
    </ChartAnalysisTableUI.SortableContainer>
  );
};
